import React from 'react'

const EditPenIcon = () => {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.1088 3.6846C16.4046 3.3996 16.4046 2.93922 16.1088 2.65422L14.3334 0.944219C14.0376 0.659219 13.5596 0.659219 13.2637 0.944219L11.7767 2.37653L14.6217 5.11691L16.1088 3.6846ZM13.8631 5.84768L11.018 3.1073L3.43121 10.415V13.1554H6.27626L13.8631 5.84768ZM18.6048 15.3477H0.396484V18.2708H18.6048V15.3477Z"
        fill="#CCCFD6"
      />
    </svg>
  )
}

export default EditPenIcon
